var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/plusIcon.4ced71ba.png","uri@2x": __webpack_public_path__ + "static/media/plusIcon.84ac8d88.png","uri@3x": __webpack_public_path__ + "static/media/plusIcon.00d96ac6.png",
    width: 24,
    height: 24
});